(() => {
  const root = document.querySelector('[data-cr-root]');
  if (!root) return;

  const selectors = [...root.querySelectorAll('[data-cr-variant]')];
  const buttons = [...root.querySelectorAll('[data-cr-add]')];
  const statuses = [...root.querySelectorAll('[data-cr-status]')];
  const badges = [...root.querySelectorAll('[data-variant]')];
  let variantId = String(root.dataset.variantId || '');

  const optionFor = (id) => selectors[0]?.querySelector(`option[value="${CSS.escape(String(id))}"]`);
  const announce = (message) => statuses.forEach((node) => { node.textContent = message; });

  function selectVariant(id, track = false) {
    variantId = String(id);
    root.dataset.variantId = variantId;
    selectors.forEach((select) => { select.value = variantId; });
    badges.forEach((badge) => badge.classList.toggle('is-selected', badge.dataset.variant === variantId));
    const option = optionFor(variantId);
    const available = option?.dataset.available === 'true';
    const price = option?.dataset.price || root.dataset.price || '$90.00';
    buttons.forEach((button) => {
      button.disabled = !available;
      button.textContent = available ? `Add to cart · ${price.replace('.00', '')}` : 'Sold out';
    });
    announce(available ? '' : `${option?.dataset.title || 'This size'} is currently sold out.`);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
    if (track && typeof window.fbq === 'function') {
      window.fbq('trackCustom', 'VariantSelected', { content_ids: [variantId], content_name: root.dataset.productTitle, content_type: 'product', value: Number(price.replace(/[^0-9.]/g, '')), currency: root.dataset.currency || 'USD' });
    }
  }

  selectors.forEach((select) => select.addEventListener('change', () => selectVariant(select.value, true)));
  badges.forEach((badge) => badge.addEventListener('click', () => selectVariant(badge.dataset.variant, true)));
  selectVariant(variantId);

  buttons.forEach((button) => button.addEventListener('click', async () => {
    const option = optionFor(variantId);
    if (option?.dataset.available !== 'true') return;
    if (location.protocol === 'file:' || location.hostname === '127.0.0.1' || location.hostname === 'localhost') {
      window.open(`https://rarely.co/products/the-canvas-cruiser-100-organic-cotton-duck-9-oz?variant=${variantId}`, '_blank', 'noopener');
      announce('Opened the selected size on Rarely.');
      return;
    }
    buttons.forEach((node) => { node.disabled = true; });
    button.textContent = 'Adding…';
    try {
      const response = window.Rarely?.cart
        ? await window.Rarely.cart({ variantId, quantity: 1 })
        : await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) });
      if (response?.ok === false) throw new Error('Unable to add');
      announce('Added to cart.');
      if (typeof window.fbq === 'function') window.fbq('track', 'AddToCart', { content_ids: [variantId], content_name: root.dataset.productTitle, content_type: 'product', value: Number((option.dataset.price || '0').replace(/[^0-9.]/g, '')), currency: root.dataset.currency || 'USD' });
    } catch (error) {
      announce('Unable to add this item. Please try again.');
    } finally {
      window.setTimeout(() => selectVariant(variantId), 1200);
    }
  }));

  const hotspotCopy = {
    fabric: { label: '01 · Material', title: '9 oz organic cotton duck', body: 'A substantial, tightly woven shell with the firm hand expected from workwear canvas.' },
    airflow: { label: '02 · Airflow', title: 'Ventilation grommets', body: 'Strategically placed crown grommets help air move on warm, still days.' },
    brim: { label: '03 · Shade', title: '2¾-inch structured brim', body: 'An oval foam brim gives useful coverage at the front and back while keeping its shape.' },
    strap: { label: '04 · Security', title: 'Paracord with cord lock', body: 'A simple locking adjustment helps the hat stay close when the wind picks up.' }
  };
  const stage = root.querySelector('[data-cr-hotspot-stage]');
  const tooltip = root.querySelector('[data-cr-tooltip]');
  const closeTooltip = () => {
    if (!tooltip) return;
    tooltip.hidden = true;
    root.querySelectorAll('[data-cr-hotspot]').forEach((node) => node.classList.remove('is-active'));
  };
  root.querySelectorAll('[data-cr-hotspot]').forEach((hotspot) => hotspot.addEventListener('click', (event) => {
    event.stopPropagation();
    const copy = hotspotCopy[hotspot.dataset.crHotspot];
    root.querySelectorAll('[data-cr-hotspot]').forEach((node) => node.classList.toggle('is-active', node === hotspot));
    tooltip.querySelector('[data-cr-tooltip-label]').textContent = copy.label;
    tooltip.querySelector('[data-cr-tooltip-title]').textContent = copy.title;
    tooltip.querySelector('[data-cr-tooltip-body]').textContent = copy.body;
    tooltip.hidden = false;
    const stageRect = stage.getBoundingClientRect();
    const hotspotRect = hotspot.getBoundingClientRect();
    const gutter = 10;
    const hotspotX = hotspotRect.left - stageRect.left + (hotspotRect.width / 2);
    const hotspotY = hotspotRect.top - stageRect.top + (hotspotRect.height / 2);
    const maxLeft = stageRect.width - tooltip.offsetWidth - gutter;
    const left = Math.min(Math.max(hotspotX + 22, gutter), Math.max(maxLeft, gutter));
    let top = hotspotY - tooltip.offsetHeight - 22;
    if (top < gutter) top = hotspotY + 28;
    top = Math.min(top, stageRect.height - tooltip.offsetHeight - gutter);
    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${Math.max(top, gutter)}px`;
  }));
  root.querySelector('[data-cr-tooltip-close]')?.addEventListener('click', (event) => { event.stopPropagation(); closeTooltip(); });
  stage?.addEventListener('click', closeTooltip);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeTooltip(); });

  const sticky = root.querySelector('[data-cr-sticky]');
  const hero = root.querySelector('[data-cr-hero]');
  if (sticky && hero && 'IntersectionObserver' in window) new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: .08 }).observe(hero);

  if (typeof window.fbq === 'function') {
    const option = optionFor(variantId);
    window.fbq('track', 'ViewContent', { content_ids: [variantId], content_name: root.dataset.productTitle, content_type: 'product', value: Number((option?.dataset.price || '0').replace(/[^0-9.]/g, '')), currency: root.dataset.currency || 'USD' });
  }
})();
